import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {MessageErrorResolver} from "../../utilities/message-error-resolver";
import {ResponseDto, ResponseWithErrorDto} from "../../models/exceptions/response-dto";
import {catchError, EMPTY, map, Observable} from "rxjs";
import {IViaCepEntityDto} from "../../models/via-cep-entity-dto";
import { LoadingService } from './loading.service';

@Injectable({
  providedIn: 'root'
})
export class ViaCepService {
  private url: string = environment.apiUrl;

  constructor(private httpClient: HttpClient,
              private messageErrorResolver: MessageErrorResolver,
              private loadingService: LoadingService) {
  }

  public getLogradouroByCep(viaTxCep: string): Observable<IViaCepEntityDto> {
    let params = new HttpParams().set("cep", viaTxCep);
    return this.httpClient.get<ResponseDto<IViaCepEntityDto>>(this.url + "/v1/via-cep/entidades", {params})
      .pipe(
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.messageErrorResolver.resolveMessage(error);
          this.loadingService.deactivate();
          return EMPTY;
        }),
      );
  }
}
